export const CASH_FUND_GUEST_ROUTES = {
  fund: {
    path: '/:eventHandle/cash-fund/:fundId',
    goTo: (eventHandle: string, fundId: string) => `/${eventHandle}/cash-fund/${fundId}`,
  },
  success: {
    path: '/:eventHandle/cash-fund/:fundId/success',
    goTo: (eventHandle: string, fundId: string) => `/${eventHandle}/cash-fund/${fundId}/success`,
  },
};
